<div class="banner">
  <div class="button-container flex align-baseline">
    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'quotation'
            ? 'selected-button'
            : 'non-selected-button'
        "
        (click)="changeSelectedView('quotation')"
        type="button"
        mat-button
      >
        Nieuwe
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'followed-quotation'
            ? 'selected-button'
            : 'non-selected-button'
        "
        (click)="changeSelectedView('followed-quotation')"
        type="button"
        mat-button
      >
        Lopende
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'rejected'
            ? 'selected-button'
            : 'non-selected-button'
        "
        (click)="changeSelectedView('rejected')"
        type="button"
        mat-button
      >
        Afgekeurde
      </button>
    </div>
  </div>
</div>

<quotation-projects *ngIf="selectedOverview === 'quotation'">
</quotation-projects>

<followed-quotation-projects *ngIf="selectedOverview === 'followed-quotation'">
</followed-quotation-projects>

<rejected-quotation-projects
  *ngIf="selectedOverview === 'rejected'"
></rejected-quotation-projects>
